/* eslint-disable */
// THIS FILE WAS GENERATED BY TRANSLATIONS-CLI ON Thu Apr 30 2020 19:30:13 GMT+0100 (Western European Summer Time) 
// DO NOT MODIFY DIRECTLY.
 
export default {
  "common": {
    "base_url": "https://loandolphin.com.au",
    "error": {
      "are_you_lost": "你失去了什么？",
      "back_home": "带我回家",
      "enquiry_not_found": "询问没有找到！",
      "generic": "哎呀！发生错误。请稍后再试。",
      "not_found": "网页未找到！",
      "oops": "哎呀",
      "recaptcha": "对不起，你似乎是一个机器人。如果你是一个真正的人，请重试。"
    },
    "external_route": {
      "about_us": "关于我们",
      "blog": "博客",
      "calculators": "计算器",
      "contact": "联系我们",
      "faq": "常见问题解答",
      "home": "loandolphin.com.au",
      "need_help": "需要帮忙？",
      "terms": "条款和条件"
    },
    "footer": {
      "address": "地址",
      "broker_associations": "与注册",
      "copyright": "LoanDolphin©2019",
      "licence": "澳大利亚信贷许可证编号：500703",
      "main_1": "我们不是一个信贷提供者，在给您的产品信息，我们不会做任何意见或建议给大家介绍一个特定的产品。",
      "main_2": "如果您决定申请产品，你会与金融机构或经纪人，而不是与LoanDolphin直接处理。",
      "main_3": "产品信息应与相关供应商（银行贷款和经纪人）得到确认，而你应该检查PDS（连接到你的报价），然后再做出决定。",
      "main_4": "这个建议是一般性质的，并没有考虑到你的目标，财务状况或需要。",
      "main_5": "考虑这个建议是否适合你。",
      "subscribe": {
        "action": "订阅",
        "error": "出问题了！请稍后再试。",
        "label": "订阅我们的新闻",
        "success": "我们已经通过电子邮件发送你一个链接，确认您的订阅。通过点击我们的电子邮件中的链接，请证实。"
      }
    },
    "header": {
      "about_us": "关于我们",
      "blog": "博客",
      "calculators": "计算器",
      "contact": "联系",
      "get_started": "入门",
      "home": "家",
      "how_it_works": "怎么运行的",
      "login": "登录"
    },
    "label": {
      "today": "今天"
    },
    "week_days": {
      "full": {
        "friday": "星期五",
        "monday": "星期一",
        "saturday": "星期六",
        "sunday": "星期日",
        "thursday": "星期四",
        "tuesday": "星期二",
        "wednesday": "星期三"
      },
      "short": {
        "friday": "周五",
        "monday": "周一",
        "saturday": "星期六",
        "sunday": "太阳",
        "thursday": "星期四",
        "tuesday": "星期二",
        "wednesday": "星期三"
      }
    }
  },
  "home": {
    "awards": {
      "title": "我们的提名奖"
    },
    "contact": {
      "action": "发信息",
      "email": "电子邮件",
      "error": "很抱歉，我们没能proccess你在这个时候请求。请确认您的信息或稍后再试。",
      "message": "信息",
      "name": "名称",
      "recaptcha": "请勾选框继续",
      "subject": "话题",
      "success_1": "感谢您联系LoanDolphin。",
      "success_2": "您的请求将被尽快我们的团队成员之一跟进。",
      "success_3": "请确保您的垃圾邮件过滤器设置为接受来自loandolphin.com.au消息。",
      "title": "想与我们取得联系？",
      "error_email": "请输入有效电子邮件。",
      "error_required": "这是必填栏。"
    },
    "hero": {
      "subtitle": "一个用于smartgroup的工作的额外补贴是可以节省的钱呢！关注银行和抵押贷款经纪人通过我们与合作伙伴LoanDolphin竞争为您的家庭贷款！",
      "title": "你帮客户省钱，现在我们帮你"
    },
    "demo": {
      "disclaimer": "*仅出于说明目的，不是真正的优惠"
    },
    "lenders": {
      "title": "有些我们可以访问许多贷款人"
    },
    "numbers": {
      "average_score": {
        "description_1": "从平均分",
        "description_2": "产品审核",
        "title": "4.9 / 5"
      },
      "average_time": {
        "description_1": "平均节省时间",
        "description_2": "每个客户",
        "title": "8小时"
      },
      "investment_loans": {
        "description_1": "利率",
        "description_2": "投资贷款",
        "prepend": "低至",
        "title": "2.99％"
      },
      "owner_loans": {
        "description_1": "利率",
        "description_2": "自住贷款",
        "prepend": "低至",
        "title": "2.79％"
      },
      "title": "你可以信任号码"
    },
    "outdated_browser": {
      "action": {
        "acknowledge": "得到它了！",
        "new_browser": "获取一个新的浏览器"
      },
      "modal": {
        "greeting": "嗨那里，水手！",
        "message": "您正在浏览未知的水域，目前不支持您的浏览器。请务必使用边缘，浏览器，Firefox或Safari浏览器的一些一帆风顺，否则，你会提前遇到一些暴风雨天气和我们的平台可能无法按预期方式工作。",
        "title": "警告"
      }
    },
    "reasons": {
      "description": "我们努力为客户提供澳大利亚最好的数字家庭贷款服务。我们的重点是你的，我们希望帮助您和您可以最终打造为所有澳大利亚人公平和透明的金融市场上最好的交易连接。这是我们的核心价值观。",
      "fair_and_open": {
        "description": "不同于其他网站，我们不收取银行和经纪公司任何加盟或按月收费。每个人都是免费为您的家庭贷款竞争。",
        "title": "公平与公开"
      },
      "free": {
        "description": "我们可以保持免费的服务归功于我们吸引借款人谁是认真的再融资或寻求通过我们独特的服务，新的购房按揭选择的能力。",
        "title": "100％免费"
      },
      "no_obligation": {
        "description": "没有承诺，你是不是锁定直至贷款了事。你选择什么是适合你的。",
        "title": "没有义务"
      },
      "quality": {
        "description": "每个经纪人和贷款人正在接受我们的批准之前筛选。他们还审议并通过客户定期评级。",
        "title": "质量有保证的"
      },
      "save_time": {
        "description": "当银行和经纪公司竞争，您提供更好的住房贷款在较短时间内取得胜利。",
        "title": "节省时间和金钱"
      },
      "secure": {
        "description": "我们使用银行级的安全技术，并允许您控制谁可以看到您的信息。",
        "title": "私密性和安全"
      },
      "title": "为什么你会爱上我们"
    },
    "title": {
      "main": "LoanDolphin和smartgroup的"
    },
    "tutorial": {
      "label": {
        "video": "观看一段简短的一分钟视频"
      },
      "step_1": {
        "description": "通过填写我们的调查形式，您告诉我们您的优先事项和财务需求开始。只需要四分钟，我们向你保证，所有这些细节将保持安全和私人在我们的平台。",
        "title": "1"
      },
      "step_2": {
        "description": "这就像一个拍卖，但你拿着锤子。我们核实贷款人相互竞争，给你在市场上最好的交易。现在，你只需要选择，知道你有所有的信息和控制，始终以饱满的透明度。",
        "title": "2"
      },
      "step_3": {
        "description": "一旦你感到快乐，你会与你所选择的贷款人或经纪人谁都会支持你通过你的应用程序连接。",
        "title": "3"
      },
      "step_4": {
        "description": "您可以检查过程和更新，随时随地。我们，LoanDolphin，将永远伴随着你的每一步，后退一步并享受乘坐。",
        "title": "4"
      },
      "title": "它是如何工作的？"
    },
    "reviews": {
      "title": "为什么我们这样做",
      "review_link_title": "回顾链接",
      "review1": {
        "content": "LoanDolphin超出我们的预期。这项服务是如此专业和包容。他们发现我们的超级竞争力的价格，我们无法找到其他地方。",
        "author": "安妮乐骑士"
      },
      "review2": {
        "content": "大力支持下，迅速作出反应。我在一个小时内有我的第一次报价。经纪公司的评论和体验的评分允许判断今后的活动的质量。",
        "author": "乔治"
      },
      "review3": {
        "content": "一流的服务。得到了很多优惠，从并与如果需要进一步调查选择。目前工程进展看起来有前途的应用程序，它应该救我，每年成本的合理费用。",
        "author": "格雷格"
      },
      "review4": {
        "content": "从球队在LoanDolphin接受服务，我的水平非常好。他们将获得在同一天回到我的问题。我感到舒服的每一步。我强烈推荐这个平台给任何人。",
        "author": "马特ķ"
      },
      "review5": {
        "content": "LoanDolphin在帮助我们找到一个更好的交易，当我们决定再融资，我们的房屋贷款非常有帮助。他们的平台是易于使用，并把我们的联系方式，一些伟大的优惠。",
        "author": "迈克尔大号"
      },
      "review6": {
        "content": "我强烈推荐这个平台，那些希望得到一个新的房屋贷款再融资或。 LoanDolphin已经帮我节省了很多时间，希望很多钱。",
        "author": "生硬的"
      },
      "review7": {
        "content": "贷款海豚是非常迅速用合适的抵押贷款经纪人和我们相比。由抵押贷款经纪人提供的服务是非常专业和友好的。他们去超越让我们一个很大的购买我们的第一个家。",
        "author": "弥敦道中号"
      }
    },
    "story": {
      "title": "我们的业务背后的故事",
      "paragraph_1": "LoanDolphin出生的时候创办Ranin门迪斯和Rod杜特拉满足于“四大”银行工作一段时间。他们看到的麻烦和挫折的客户以最优惠价格保证合适的贷款往往经历。他们知道必须有一个更好的办法。使这一过程透明的一种方式，公平，确保客户收到的方便获取合适的贷款。",
      "paragraph_2": "LoanDolphin是唯一真正以客户为中心的数字化贷款服务，帮助您获得比广告上的利率降低。我们不与任何一家银行或抵押贷款经纪人和下属保持专注于为所有澳大利亚人一个透明的金融市场。"
    },
    "alternate": {
      "accesspay": {
        "title": "在感谢AccessPay短短几分钟内在线获得贷款的健康检查",
        "subtitle": "其中之一是一个AccessPay客户的津贴是，你可以节省的钱你的抵押贷款呢！关注银行和抵押贷款经纪人通过我们与合作伙伴LoanDolphin竞争为您的家庭贷款！"
      },
      "advantage": {
        "title": "在感谢优势短短几分钟内在线获得贷款的健康检查",
        "subtitle": "其中之一是一个优势工资包装客户的特殊待遇的是，你可以节省的钱你的抵押贷款呢！关注银行和抵押贷款经纪人通过我们与合作伙伴LoanDolphin竞争为您的家庭贷款！"
      },
      "smartsalary": {
        "title": "在感谢Smartsalary短短几分钟内在线获得贷款的健康检查",
        "subtitle": "其中之一是一个Smartsalary客户的津贴是，你可以节省的钱你的抵押贷款呢！关注银行和抵押贷款经纪人通过我们与合作伙伴LoanDolphin竞争为您的家庭贷款！"
      },
      "autopia": {
        "title": "在拜驰短短几分钟内在线获得贷款的健康检查",
        "subtitle": "其中之一是一个驰客户的津贴是，你可以节省的钱你的抵押贷款呢！关注银行和抵押贷款经纪人通过我们与合作伙伴LoanDolphin竞争为您的家庭贷款！"
      },
      "smartleasing": {
        "title": "在感谢Smartleasing短短几分钟内在线获得贷款的健康检查",
        "subtitle": "其中之一是一个Smartleasing客户的津贴是，你可以节省的钱你的抵押贷款呢！关注银行和抵押贷款经纪人通过我们与合作伙伴LoanDolphin竞争为您的家庭贷款！"
      },
      "selectus": {
        "title": "在感谢Selectus短短几分钟内在线获得贷款的健康检查",
        "subtitle": "其中之一是一个Selectus客户的津贴是，你可以节省的钱你的抵押贷款呢！关注银行和抵押贷款经纪人通过我们与合作伙伴LoanDolphin竞争为您的家庭贷款！"
      }
    }
  }
}